<template>
  <div>
    <v-alert
      colored-border
      dense
      border="left"
      color="blue"
      class="bg-notif mb-0 body-2 mb-5"
      v-if="
        $getDeepObj(detail, 'psp_diklat_sekolah.data.k_ajuan_diklat_psp') === 5 ||
          $getDeepObj(detail, 'k_ajuan_diklat_psp') === 5
      "
    >
      <h3 class="title">
        <b>Catatan Perbaikan:</b>
      </h3>
      <div>
        {{ $getDeepObj(detail, 'psp_diklat_sekolah.data.alasan') || $getDeepObj(detail, 'alasan') || '-' }}
      </div>
    </v-alert>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content class="py-0">
            <v-row no-gutters>
              <v-col class="py-0 text-right" cols="12">
                <v-chip
                  :color="
                    colors[
                      this.$getDeepObj(detail, 'psp_diklat_sekolah.data.k_ajuan_diklat_psp') ||
                        this.$getDeepObj(detail, 'k_ajuan_diklat_psp')
                    ]
                  "
                  dark
                >
                  {{
                    $getDeepObj(detail, 'psp_diklat_sekolah.data.m_ajuan_diklat_psp.data.keterangan') ||
                      $getDeepObj(detail, 'm_ajuan_diklat_psp.data.keterangan')
                  }}
                </v-chip>
              </v-col>
              <v-col class="py-0" cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 mt-3">
                    <div class="subtitle-2 black--text">
                      {{ $getDeepObj(detail, 'sekolah.data.nama') || $getDeepObj(detail, 'nama') || '-' }}
                    </div>
                    <div class="caption">
                      <span>
                        <v-icon small left>mdi-city</v-icon>
                        {{
                          $getDeepObj(detail, 'sekolah.data.m_jenjang.data.singkat') ||
                            $getDeepObj(detail, 'm_jenjang.data.singkat') ||
                            '-'
                        }}
                      </span>
                      <br />
                      <span>
                        <v-icon small left>mdi-map-marker</v-icon>
                        {{ $getDeepObj(detail, 'sekolah.data.alamat') || $getDeepObj(detail, 'alamat') || '-' }}
                      </span>
                      <br />
                      <span class="ml-7">
                        {{ $getDeepObj(detail, 'sekolah.data.m_kota.data.keterangan') || '-' }} -
                        {{ $getDeepObj(detail, 'sekolah.data.m_propinsi.data.keterangan') || '-' }}
                      </span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="pt-0" cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption grey--text">Kepala Sekolah</span>
                        <div class="ma-0">
                          <div class="mb-1" style="font-size: 15px">
                            {{
                              $getDeepObj(detail, 'ptk_kasek.data.nama') ||
                                $getDeepObj(detail, 'psp_diklat_sekolah.data.ptk_kasek.data.nama') ||
                                '-'
                            }}
                          </div>
                          <div class="body-3 grey--text text--darken-1">
                            SIMPKB ID:
                            <span class="black--text">
                              {{
                                $getDeepObj(detail, 'ptk_kasek.data.ptk_id') ||
                                  $getDeepObj(detail, 'psp_diklat_sekolah.data.ptk_kasek.data.ptk_id') ||
                                  '-'
                              }}
                            </span>
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0" v-if="$getDeepObj(meta, 'wakasek') || $getDeepObj(detail, 'ptk_id_wakasek')">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Wakasek Kurikulum SMK</span>
                        <p class="ma-0">
                          <span>
                            {{
                              $getDeepObj(meta, 'wakasek.nama') || $getDeepObj(detail, 'ptk_wakasek.data.nama') || '-'
                            }}
                          </span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="py-0" cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <p class="caption grey--text">
                          Pengawas Sekolah
                          <template v-if="Number($getDeepObj(detail, 'gelombang_profil')) === 1">
                            PKP 1
                          </template>
                        </p>
                        <div class="ma-0">
                          <div class="mb-1" style="font-size: 15px">
                            {{
                              $getDeepObj(
                                detail,
                                `psp_diklat_pengawases.data.${$getDeepObj(detail, 'psp_diklat_pengawases.data').length -
                                  1}.ptk.data.nama`
                              ) || '-'
                            }}
                          </div>
                          <div class="body-3 grey--text text--darken-1">
                            SIMPKB ID:
                            <span class="black--text">
                              {{
                                $getDeepObj(
                                  detail,
                                  `psp_diklat_pengawases.data.${$getDeepObj(detail, 'psp_diklat_pengawases.data')
                                    .length - 1}.ptk.data.ptk_id`
                                ) || '-'
                              }}
                            </span>
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="Number($getDeepObj(detail, 'gelombang_profil')) === 1" class="py-0" cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Pengawas Sekolah PKP 2</span>
                        <p class="ma-0">
                          <span>{{ $getDeepObj(detail, `pengawas_ekstensi.ptk.nama`) || '-' }}</span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card flat class="mb-5">
      <v-card-text class="pt-0">
        <v-toolbar flat>
          <v-toolbar-title class="body-1">Daftar Peserta Guru</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-divider />
        <!--List-->
        <base-list-table
          :hideHeader="true"
          :loading="false"
          :item="$getDeepObj(detail, 'psp_diklat_gurus.data') || []"
          :total="($getDeepObj(detail, 'psp_diklat_gurus.data') || []).length || 0"
          :usePaging="false"
        >
          <template slot-scope="{ item }">
            <td class="mx-0 px-0">
              <v-list-item
                dense
                :class="['mx-0', 'lighten-5', +item.gelombang === 1 && +item.is_ganti === 1 ? 'red' : '']"
              >
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="mt-3">
                          <span class="caption grey--text">Mata Pelajaran</span>
                          <div style="font-size: 15px">
                            {{ $getDeepObj(item, 'm_mapel_psp.data.keterangan') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="mt-3">
                          <span class="caption grey--text">Status</span>
                          <div style="font-size: 15px">
                            {{ $isObject($getDeepObj(item, 'ptk.data.ptk_sekolah')) ? 'Satminkal' : 'Non Satminkal' }}
                            -
                            {{ $getDeepObj(item, 'ptk.data.m_pegawaidata.is_pns') ? 'PNS' : 'Non PNS' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="mt-3">
                          <span class="caption grey--text">Sebagai</span>
                          <div>
                            <v-chip
                              :color="($getDeepObj(item, 'is_cadangan') || 0) === 1 ? 'info' : 'success'"
                              class="white--text"
                            >
                              {{
                                ($getDeepObj(item, 'is_cadangan') || 0) === 1
                                  ? 'Guru Cadangan'
                                  : `Guru ${$getDeepObj(item, 'm_mapel_psp.data.kelompok') || ''}`
                              }}
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="mt-3">
                          <span class="caption grey--text">Nama Peserta</span>
                          <div class="mb-1" style="font-size: 15px">
                            {{ $getDeepObj(item, 'ptk.data.nama') || '-' }}
                          </div>
                          <div class="grey--text text--darken-1 body-3">
                            SIMPKB ID:
                            <span class="black--text">{{ $getDeepObj(item, 'ptk.data.ptk_id') || '-' }}</span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0" v-if="+item.gelombang === 1 && +item.is_ganti === 1">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Keterangan</span>
                          <p>
                            Diganti / mengundurkan diri di Kelompok A
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseListTable from '@components/base/BaseListTable';
import { mapState } from 'vuex';
export default {
  name: 'FormInfo',
  components: { BaseListTable },
  props: {
    detail: {
      default: () => {},
    },
    meta: {
      default: () => {},
    },
  },

  data() {
    return {
      colors: {
        2: 'info',
        4: 'success',
        5: 'warning',
      },
    };
  },

  computed: {
    ...mapState('preferensi', {
      diklat: (state) => (state.data && state.data.diklat) || {},
    }),
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
